import { Theme } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';

import { textGrayB } from "../../../../DashStyleGuides";

export const useStyles = makeStyles((theme: Theme) => ({
  title: {
    flex: "1 1 100%",
    fontWeight: "bold",
    fontFamily: "Manrope",
    fontSize: 16,
    color: textGrayB,
  },
  toolbar: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    height: 34,
  },
  box: {
    flexGrow: 1,
  },
  mainDiv: {
    width: "97%",
    height: "300px",
    margin: 15,
  },
  infoText: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "24px",
    color: "#667085",
  },
  total: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  totalText: {
    fontSize: "18px",
    color: "#344054",
  },
  footer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "5px",
  },
}));
